@if (visible) {
  <div #overlayMenuWrapper>
    <div class="absolute z-20 w-full bg-white dark:bg-dark-card px-4 py-4 rounded-md flex flex-col border border-gray-300 dark:border-dark-border shadow-md max-h-96 overflow-y-auto">
      @for (item of flattenedResults; track i; let i = $index) {
        @if (item.isCategory) {
          <div class="flex">
            <div class="rounded-md bg-gray-100 dark:bg-dark-hover text-xs text-gray-500 dark:text-dark-muted py-2 px-2">{{ item.category | translate }}</div>
          </div>
        } @else {
          <div [ngClass]="{ 'ml-4 pt-4 border-l border-l-gray-100 dark:border-l-dark-border pl-4': item.isGrouped }">
            <a
              class="flex flex-col font-normal text-secondary dark:text-dark-muted bg-white dark:bg-dark-card ease-in-out duration-200 rounded-md py-3 px-3 mb-2 hover:bg-gray-100 dark:hover:bg-dark-hover hover:text-primary dark:hover:text-dark-text"
              [ngClass]="{ '!border-none !bg-gray-100 dark:!bg-dark-hover': focusItem === i }"
              (mousedown)="$event.preventDefault()"
              (click)="$event.preventDefault(); emitClick(item)"
              href="#"
              tabindex="-1"
              #listItem
            >
              @if (item.isBack) {
                <span class="flex items-center gap-2">
                  <i-lucide [name]="backIcon" size="18" aria-hidden="true"></i-lucide>
                  {{ 'common.back' | translate }}
                </span>
              } @else {
                <div class="flex items-start gap-2">
                  @if (item.icon) {
                    <span class="shrink-0 mt-0.5" [title]="item.iconLabel ? (item.iconLabel | translate) : ''">
                      <i-lucide [name]="item.icon" size="18" aria-hidden="true"></i-lucide>
                      @if (item.iconLabel) {
                        <span class="sr-only">{{ item.iconLabel | translate }}</span>
                      }
                    </span>
                  }
                  <div class="min-w-0">
                    @if (Array.isArray(item.title)) {
                      @for (title of item.title; track titleIndex; let titleIndex = $index) {
                        <div
                          [ngClass]="{'text-sm': titleIndex > 0}"
                          [innerHTML]="title | highlight: searchQuery"></div>
                      }
                    } @else {
                      <div [innerHTML]="item.title | highlight: searchQuery"></div>
                    }
                    @if (item.hasChildren) {
                      <span class="flex items-center gap-1 text-sm">
                        {{ (item.childrenLabel || 'search.results.refine') | translate }}
                        <i-lucide [name]="nextIcon" size="16" aria-hidden="true"></i-lucide>
                      </span>
                    }
                  </div>
                </div>
              }
            </a>
          </div>
        }
      }
      @if (loading) {
        <output class="block py-3 font-normal text-secondary">
          {{ 'common.loading' | translate }}
        </output>
      } @else if (loadFailed) {
        <div class="py-3 font-normal text-secondary" role="alert">
          <p>{{ (loadNotFound ? 'search.results.notFound' : 'search.results.loadFailed') | translate }}</p>
          @if (!loadNotFound) {
            <button type="button" class="underline mt-2" (click)="retry.emit()">
              {{ 'search.results.retry' | translate }}
            </button>
          }
        </div>
      } @else if (!hasResults) {
        <output class="flex font-normal text-secondary">
          {{ 'search.results.noresults' | translate }}
        </output>
      }
    </div>
  </div>
}
